/**
 * `/chat-dev/cards-demo` — dev-only fixture playground for <ToolCard>
 * variants (Stream B addendum §7 substitute for Storybook).
 *
 * URL note: same TanStack underscore-prefix constraint as Stream C's
 * `/chat-dev/trace-demo`. We use `/chat-dev/cards-demo` (not the
 * literal `/_chat/cards-demo` from the addendum) because TanStack's
 * file-based router consumes `_`-prefixed segments as layout markers.
 *
 * The page component itself gates on `import.meta.env.DEV`, so a
 * production-bundle user typing the URL by hand gets a polite stub.
 *
 * Wave-17 Item 1.1 — lazy-loaded; never shipped to production users.
 */
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/chat-dev/cards-demo")({
  component: lazyRouteComponent(() => import("@/pages/Portal/CardsDemo/Page")),
});
